import React, { useState } from "react";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { loginRequest } from "./Services/authService";
import { AuthError, EventType, InteractionType } from "@azure/msal-browser";
import { AuthenticatedTemplate } from "@azure/msal-react";
import CreateUser from "./Services/CreateUser";
import { useSelector } from "react-redux";
import UsersList from "./pages/master/User/UsersTable";
import Axios from "./Utils/AxiosConfig/axiosConfig";

// SWRAS_ROUTE_CODE (SpringWater/constants.ts), kept local so the lazy Spring Water chunk is not pulled in
const SWRA_ROUTE = "/spring-water";
// MSAL 2.x error codes for offline / failed token-endpoint requests
const NETWORK_ERROR_CODES = [
  "no_network_connectivity",
  "post_request_failed",
  "get_request_failed",
  "network_error",
  "endpoints_resolution_error",
];

function AuthAD(props: any) {
  const { instance } = useMsal();
  useMsalAuthentication(InteractionType.Redirect, loginRequest);

  instance.addEventCallback((message: any) => {
    if (message.eventType === EventType.LOGIN_SUCCESS) {
      const { payload } = message;
      CreateUser(payload.accessToken, payload.account);
    }
    // Handled login error for BrowserAuthError Status Code
    if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      // Spring Water screens stay open on kiosks: a network blip must not force a full-page
      // login; the next station poll / renewal timer retries. Any other failure still redirects.
      const isSwraNetworkError =
        window.location.pathname.includes(SWRA_ROUTE) &&
        NETWORK_ERROR_CODES.includes((message.error as AuthError)?.errorCode);
      if (!isSwraNetworkError) instance.loginRedirect(loginRequest);
    }
  });

  return <AuthenticatedTemplate>{props.children}</AuthenticatedTemplate>;
}

export default AuthAD;
